module.exports = __webpack_public_path__ + "static/media/school-profile-ad9.d7a86b12.png";